import React from 'react';
import {useTranslation} from 'react-i18next';
import {WideHeader} from '../../layout/wide';

interface Partner {
  nameKey: string;
  logo: string;
  descriptionKey: string;
  link: string;
  external: boolean;
}

const PARTNERS: Partner[] = [
  {
    nameKey: 'partners.mcbw.name',
    logo: '/images/partners/mcbw.svg',
    descriptionKey: 'partners.mcbw.description',
    link: '/mcbw',
    external: false
  },
  {
    nameKey: 'partners.nprh.name',
    logo: '/images/partners/nprh.svg',
    descriptionKey: 'partners.nprh.description',
    link: 'https://www.gov.pl/web/nauka/narodowy-program-rozwoju-humanistyki',
    external: true
  },
  {
    nameKey: 'partners.uj.name',
    logo: '/images/partners/uj.svg',
    descriptionKey: 'partners.uj.description',
    link: 'https://www.uj.edu.pl/',
    external: true
  },
  {
    nameKey: 'partners.kbf.name',
    logo: '/images/partners/kbf.svg',
    descriptionKey: 'partners.kbf.description',
    link: 'https://kbf.krakow.pl/',
    external: true
  }
];

const Partners: React.FC = () => {
  const {t} = useTranslation();

  return (
    <>
      <WideHeader
        title={t('partners.title')}
        introduction={t('partners.introduction')}
        narrow={true}
      />

      <section className="bg-gray-100 py-8">
        <div className="container mx-auto px-4 max-w-4xl">
          <div className="space-y-8">
            {PARTNERS.map((partner, index) => (
              <a
                key={index}
                href={partner.link}
                target={partner.external ? '_blank' : '_self'}
                rel={partner.external ? 'noopener noreferrer' : undefined}
                className="block bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300 p-6"
              >
                <div className="flex flex-col md:flex-row gap-6 items-start">
                  <div className="flex-shrink-0 w-full md:w-48 flex items-center justify-center">
                    <img
                      src={partner.logo}
                      alt={t(partner.nameKey)}
                      className="max-w-full h-auto max-h-32 object-contain"
                    />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-xl font-cinzel font-bold text-gray-900 mb-3">
                      {t(partner.nameKey)}
                    </h3>
                    <p className="text-gray-700 leading-relaxed">
                      {t(partner.descriptionKey)}
                    </p>
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Partners;
